'use client';

import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import MarketingInteriorLayout from '@/components/home-landing/MarketingInteriorLayout';
import WebsiteFooter from '@/components/website/WebsiteFooter';

const WEBSITE_CONTENT_SX = {
  bgcolor: 'background.default',
  color: '#0a0a0a',
  flex: '1 1 0',
  minHeight: 0,
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
};

export default function WebsiteInteriorScrollLayout({ children, contentSx }) {
  return (
    <MarketingInteriorLayout
      contentSx={contentSx ? { ...WEBSITE_CONTENT_SX, ...contentSx } : WEBSITE_CONTENT_SX}
      showWebsiteFooter={false}
    >
      <Box sx={{ flex: '0 0 auto', flexShrink: 0, width: '100%' }}>{children}</Box>
      <Box sx={{ flexShrink: 0, width: '100%' }}>
        <WebsiteFooter />
      </Box>
    </MarketingInteriorLayout>
  );
}

WebsiteInteriorScrollLayout.propTypes = {
  children: PropTypes.node.isRequired,
  contentSx: PropTypes.object,
};
